import CardComponent from './CardComponent';

const Contact = () => {
    return (
        <CardComponent pageTitle='contact' />
    )
}

export default Contact;